import { Select } from "ol/interaction";
import Style from "ol/style/Style";
import Feature from "ol/Feature";
import { Polygon } from "ol/geom";
import axios from "axios";

function getCenterBBOX(bbox) {
  const x = (bbox[0] + bbox[2]) / 2;
  const y = (bbox[1] + bbox[3]) / 2;

  return [x - 1, x + 1, y - 1, y + 1];
}

function createInteraction(eventInteraction, layer) {
  return new Select({
    condition: function (event) {
      return event.type === eventInteraction;
    },
    layers: [layer],
  });
}

function styleDalleSelect(idDalleSurvol, dalleSelect) {
  // fonction permettant d'ajuster le style au survol d'une dalle
  // on parcout la liste des dalles selectionner
  dalleSelect.forEach((dalle) => {
    // si la dalle est selectionner alors au survol on lui laisse le style select et on retourne true
    if (dalle.id === idDalleSurvol) {
      return true;
    }
  });
  // si la dalle n'est pas dans la liste on retourne false
  return false;
}

function isSelectedMnx(idClick, listDallesSelected) {
  for (let dalle of listDallesSelected) {
    if (dalle.id === idClick) {
      return true;
    }
  }
  return false;
}

async function getDalles(url, minX, minY, maxX, maxY) {
  const firstResponse = await axios.get(
    url.concat(`&bbox=${minX},${minY},${maxX},${maxY},EPSG:2154`)
  );

  if (firstResponse.data.totalFeatures > "5000") {
    const secondResponse = await axios.get(
      url.concat(
        `&bbox=${minX},${minY},${maxX},${maxY},EPSG:2154&count=5000&startIndex=5000`
      )
    );

    let features = firstResponse.data.features;
    features= [...features,...secondResponse.data.features];
    return features;
  }

  return firstResponse.data.features;
}

function createDalleFeature(dalle) {
  // fonction qui génère la création de dalle on part du principe que c'est une dalle de type MNS
  const dalleGeometry = dalle.geometry;
  const dalleFeature = new Feature({
    geometry: new Polygon(dalleGeometry.coordinates),
  });
  const splitName = dalle.properties.name.split("_");
  const id = splitName.slice(1, 4).join("_");

  dalleFeature.setProperties({
    id: id,
    bbox: dalle.bbox,
    mns: {
      name: dalle.properties.name,
      url: dalle.properties.url,
    },
  });

  return dalleFeature;
}

async function getDallesMnhMnt(bbox) {
  const [minX, maxX, minY, maxY] = getCenterBBOX(bbox);
  const responseMNH = await getDalles(
    process.env.REACT_APP_DALLES_URL_MNH,
    minX,
    minY,
    maxX,
    maxY
  );
  const responseMNT = await getDalles(
    process.env.REACT_APP_DALLES_URL_MNT,
    minX,
    minY,
    maxX,
    maxY
  );

  let dalleMNH = null;
  let dalleMNT = null;

  if (responseMNH[0]) {
    dalleMNH = {
      name: responseMNH[0].properties.name,
      url: responseMNH[0].properties.url,
    };
  }
  if (responseMNT[0]) {
    dalleMNT = {
      name: responseMNT[0].properties.name,
      url: responseMNT[0].properties.url,
    };
  }
  return [dalleMNH,dalleMNT];
}

function getDallesMnhMntRapide(dalleMns) {

  const dalleMnh = {
    name: dalleMns.name.replace("MNS", "MNH"),
    url: dalleMns.url.replaceAll("MNS", "MNH"),
  };

  const dalleMnt = {
    name: dalleMns.name.replace("MNS", "MNT"),
    url: dalleMns.url.replaceAll("MNS", "MNT"),
  };

  return [dalleMnh, dalleMnt]
}

function zoomToPolygon(item, niv_zoom, map) {
  // fonction qui permet de zoomer sur un polygon ou une dalle (le terme openlayer pour une dalle est polygon)
  if (item) {
    // recuperation de l'extent de du polygon
    const polygon_extent = item.values_.geometry.extent_;
    map.getView().fit(polygon_extent, { padding: [50, 50, 50, 50] });
    map.getView().setZoom(niv_zoom);
  }

  return map;
}

export {
  createInteraction,
  styleDalleSelect,
  isSelectedMnx,
  getDalles,
  createDalleFeature,
  zoomToPolygon,
  getDallesMnhMnt,
  getDallesMnhMntRapide
};
